import React, { useEffect, useState } from "react";

import { Box, Typography, useMediaQuery , Skeleton,} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import FeaturesHeroCard from "../../components/cards/FeaturesHeroCard";
import acc3_eng from "../../assets/acc3_eng.png"; // Adjust the path as necessary
import acc3_spa from "../../assets/acc3_spa.png"; // Adjust the path
import i18next from "i18next";
import { BASE_URL } from "../../components/BASE_URL";
const CompanyMapSection = () => {
    const { t ,i18n} = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
    const [loadingCompanyMap, setLoadingCompanyMap] = useState(true);
  const [companyMapData, setCompanyMapData] = useState(null);

  const parseFeatureNames = (list) => {
    try {
      const items = Array.isArray(list)
        ? list
        : list
          ? JSON.parse(list)
          : [];
      return items.map((f) => f.name);
    } catch {
      return [];
    }
  };

useEffect(() => {
  const fetchCompanyMap = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Interactive_Company`
      );
      const json = await res.json();
      if (!json.error && json.data?.length > 0) {
        const section = json.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        if (item) {
          setCompanyMapData({
            title: item.title,
            description: item.description,
            features: parseFeatureNames(item.list),
          });
        }
      }
    } catch (err) {
      console.error("Error fetching Interactive_Company:", err);
    } finally {
      setLoadingCompanyMap(false);
    }
  };

  fetchCompanyMap();
}, [i18n.language]);

    return (
         <Box id="company-map-section">
      {loadingCompanyMap ? (
        <Box sx={{ p: 3 }}>
          <Skeleton variant="text" width={280} height={50} />
          <Skeleton variant="text" width={520} height={28} />
          <Skeleton variant="rectangular" width="100%" height={180} sx={{ mt: 2 }} />
        </Box>
      ) : (
        <FeaturesHeroCard
          bgColor="#EFF4F8"
          image={i18next.language === "es" ? acc3_spa : acc3_eng}
          imagePosition="left"
          title={companyMapData?.title}
          description={companyMapData?.description}
          features={companyMapData?.features}
        />
      )}
    </Box>
    );
};

export default CompanyMapSection;



